angular.module('common').factory('Selectors::Version', [function () {
  function getVersion (object) {
    return (object && object.version) || undefined;
  }

  return {
    getVersion: getVersion,
  };
}]);
